export const muiEditorSidePanelTestIds = {
  content: 'side-panel-content',
  documentTab: 'document-side-panel-tab',
  buildTab: 'build-side-panel-tab',
  uploadsTab: 'uploads-side-panel-tab',
  designTab: 'design-side-panel-tab',
  signaturesTab: 'signatures-side-panel-tab',
  variablesTab: 'variables-side-panel-tab',
  aiTab: 'ai-assistant-side-panel-tab',
};
